import { createInstance } from '@/helpers/api/base'
import { useAuthStore } from '@/store/auth-store'
import { Log } from '@/types/logs'
import { useAppQuery } from '@/helpers/api/query'
import { useWorkstationStore } from '@/modules/Workstation/store'

export const useGetAllUnfinishedLogsForController = () => {
    const { xUserShiftId } = useAuthStore()
    const { routes } = useWorkstationStore()

    return useAppQuery<Log[]>({
        queryKey: ['allUnfinishedLogsForController', xUserShiftId],
        queryFn: () =>
            createInstance({
                url: `/controller-logs/controller/unfinished`,
                method: 'GET',
                params: {
                    Routes: routes.map((route) => route.route)
                },
                paramsSerializer: { indexes: null },
            }),
        enabled: !!xUserShiftId,
    })
}
